import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTechniqueChat } from "./TechniqueChatProvider";

export function TechniqueChatTrigger() {
  const { isOpen, toggleChat, technique } = useTechniqueChat();

  if (!technique) return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            onClick={toggleChat}
            size="lg"
            className={`
              fixed bottom-6 right-6 z-50
              h-14 w-14 rounded-full shadow-lg
              bg-gradient-to-r from-violet-600 to-indigo-600
              hover:from-violet-700 hover:to-indigo-700
              transition-all duration-200
              ${isOpen ? "scale-0 opacity-0" : "scale-100 opacity-100"}
            `}
            aria-label="Open chat assistant"
          >
            <MessageCircle className="h-6 w-6 text-white" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="left" className="mr-2">
          <p>Ask about this technique</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
